import $ from "jquery"

$('.js-navbar-dm-trigger').on('click', function(){
    $(this).toggleClass('nav_bar-trigger--active');
    $('html, body').toggleClass('overflow-hidden position-relative ios-notouch');
    $('.js-navbar-dm, .js-navbar-dm-overlay').toggle();
});